import ExcelJS from 'exceljs'
import { Button } from '@mantine/core'
import { IResponseFindContactRowData } from '@apiinterface/IContact'

const generateAndDownloadExcel = (data: IResponseFindContactRowData[]) => {
    // Create a new Excel workbook
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('Sheet 1')

    // Add headers
    worksheet.addRow([
        'ไอดีรายการข้อมูล',
        'quiz_id',
        'เรื่องที่ต้องต้องการปรึกษา',
        'ชื่อ',
        'นามสกุล',
        'อีเมล',
        'เบอร์โทรศัพท์',
        'เปิดเผยข้อมูล',
        'ทำแบบประเมินเมื่อ',
        'รหัสบุคคล',
        'ประเภทบุคคล',
        'Q1 (เป้าหมายชีวิต)',
        'Q2 (เงินออมต่อเดือน)',
        'Q3 (แนวความคิด)',
        'Q4 (เคยคำนวณ)',
        'ประกัน mtl',
        'ประกันอื่นๆ',
        'คลิกค้นหา',
    ])

    // Add data
    data.forEach((item) => {
        worksheet.addRow([
            item.id,
            item.quiz_id,
            item.topic,
            item.firstname,
            item.lastname,
            item.email,
            item.mobileno,
            item.disclosing,
            item.created_at,
            item.person_id,
            item.person_type,
            item.question_1,
            item.question_2,
            item.question_3,
            item.question_4,
            item.life_insurance_mtl,
            item.life_insurance_other,
            item.click_tracking_1,
        ])
    })

    // Generate the Excel file and download it
    workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'data.xlsx'
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
    })
}

const DownloadContactExcel = ({
    data,
}: {
    data: IResponseFindContactRowData[]
}) => {
    return (
        <Button
            mt='26px'
            onClick={() => {
                generateAndDownloadExcel(data)
            }}
        >
            Download Excel
        </Button>
    )
}

export default DownloadContactExcel
